import React from "react";

const RatingBar = ({
  image = "/icons/icon_question.png",
  unratedImage,
  direction,
  length,
  onClick,
  rating,
  imageSize,
  marginLeft,
  marginRight,
  fixedHeight,
}) => {
  const images = [5, 4, 3, 2, 1];

  function clickImage(rating) {
    if (onClick) onClick(rating);
  }
  return (
    <div
      className={direction}
      style={{
        marginLeft,
        marginRight,
        width: direction == "divRow" ? length : null,
        height: direction == "divColumn" ? length : null,
        justifyContent: "space-around",
      }}
    >
      {images
        .sort((a, b) => {
          return direction == "divRow" ? (a > b ? 1 : -1) : a < b ? 1 : -1;
        })
        .map((r) => (
          <img
            src={unratedImage ? (r > rating ? unratedImage : image) : image}
            style={{
              cursor: "pointer",
              objectFit: "contain",
              filter: r > rating ? "grayscale(100%)" : null,
              width: direction == "divRow" ? imageSize : null,
              height:
                direction == "divColumn" ? imageSize : fixedHeight ?? null,
            }}
            onClick={() => {
              clickImage(r);
            }}
            key={r}
          />
        ))}
    </div>
  );
};

export default RatingBar;
